import React from 'react';

function HomePageCategorySkeleton() {
  return (
    <section className="flex gap-x-[8px] gap-y-[12px] md:gap-x-[16px] md:gap-y-[24px] w-full overflow-x-hidden px-8">
      {Array(9)
        .fill(null)
        .map((_, index) => (
          <div
            key={`home-page-category-skeleton-${index}`}
            className="bg-skeleton animate-pulse w-full min-w-[130px] max-w-[130px] lg:min-w-[164px] lg:max-w-[164px] h-[160px] lg:h-[196px] flex flex-col justify-center items-center gap-[8px] p-6 lg:p-16 rounded-xl shadow-trending-categories-search cursor-pointer hover:shadow-card-hover"
          >
            <div className="w-full h-full flex flex-col items-center gap-2">
              <div className="w-[96px] h-[96px] lg:w-[124px] lg:h-[124px] flex justify-center items-center" />
            </div>
          </div>
        ))}
    </section>
  );
}

export default HomePageCategorySkeleton;
